import { Dropdown } from "flowbite-react";
import { Link } from "react-router-dom";

export function DropdownButton({ label, trigger, items, header }) {
  return (
    <Dropdown
      label={label || ""}
      className={"hover:border border border-gray-100 w-[200px] bg-white"}
      renderTrigger={() => trigger}
      dismissOnClick={true}
      placement="bottom-end"
    >
      {header && <Dropdown.Header className="mb-2">{header}</Dropdown.Header>}
      {/* {items.map((item, index) => {
        const { to, onClick, name, border, hidden } = item;

        if (hidden) return null;

        const isEdit = String(name || "").toLowerCase() === "edit";

        const baseClass =
          "rounded-0 w-full h-10 flex items-center px-4 font-normal text-sm";
        const hoverClass = isEdit
          ? "bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] text-white"
          : "hover:bg-gray-50";
        const borderClass = border ? "border-b border-gray-200" : "";

        return (
          <Dropdown.Item key={index} className="p-0 !bg-none hover:!bg-none">
            {to ? (
              <Link
                to={to}
                className={`${baseClass} ${hoverClass} ${borderClass}`}
              >
                {name}
              </Link>
            ) : (
              <button
                onClick={onClick}
                className={`${baseClass} ${hoverClass} ${borderClass}`}
              >
                {name}
              </button>
            )}
          </Dropdown.Item>
        );
      })} */}

      {items.map((item, index) => {
  const { to, onClick, name, border, hidden } = item;

  if (hidden) return null;

  const isEdit = String(name || "").toLowerCase() === "edit";

  const baseClass =
    "rounded-0 w-full h-10 flex items-center px-4 font-normal text-sm";
  const hoverClass = isEdit
    ? "bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] text-white"
    : "hover:bg-gray-50";
  const borderClass = border ? "border-b border-gray-200" : "";

  return (
    <Dropdown.Item key={index} className="p-0 !bg-none hover:!bg-none">
      {to ? (
        <Link
          to={to}
          className={`${baseClass} ${hoverClass} ${borderClass}`}
        >
          {name}
        </Link>
      ) : (
        <button
          onClick={onClick}
          className={`${baseClass} ${hoverClass} ${borderClass}`}
        >
          {name}
        </button>
      )}
    </Dropdown.Item>
  );
})}
    </Dropdown>
  );
}
